import { render, staticRenderFns } from "./Cisgendered.vue?vue&type=template&id=062c96bf&"
import script from "./Cisgendered.vue?vue&type=script&lang=js&"
export * from "./Cisgendered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports